<template>
    <disposition
        :location="location"
        :callActive="callActive"
        :dispositionOpen="dispositionOpen"
        @clicked="restart"
        @collapse="dispositionOpen = false"
    >
        <v-btn
            data-testid="calltracker-disposition-btn"
            class="calltracker-disposition-btn mx-2"
            v-show="callActive"
            :color="callLength"
            :outlined="!flash"
            @click.stop="stopTimer"
        >
            <v-layout align-center justify-space-between>
                <v-flex>
                    <v-layout>
                        <span class="text-h6 mr-1" v-html="emoji"></span>
                    </v-layout>
                </v-flex>
                <v-flex>
                    <span>Current Call: {{ hours }} : {{ minutes | zeroPad }} : {{ seconds | zeroPad }}</span>
                </v-flex>
                <v-flex>
                    <v-icon right>call_end</v-icon>
                </v-flex>
            </v-layout>
        </v-btn>
    </disposition>
</template>

<script>
/* eslint-disable no-return-assign */
import Disposition from "@/components/Disposition";

export default {
  data() {
    return {
      nowTime: 0,
      diffTime: 0,
      startTime: 0,
      callActive: false,
      dispositionOpen: false,
      location: "callTracker",
      timeTracker: ""
    };
  },

  methods: {
    startTimer() {
      this.callActive = true;
      if (localStorage.getItem("callStarted") && !localStorage.getItem("callStartTime")) {
        localStorage.setItem("callStartTime", new Date().getTime());
        this.nowTime = new Date().getTime();
        this.trackCallTime();
      } else if (localStorage.getItem("callStarted") && localStorage.getItem("callStartTime")) {
        this.diffTime = localStorage.getItem("callTime");
        this.trackCallTime();
      } else {
        this.callActive = false;
        return;
      };
    },

    trackCallTime() {
      this.timeTracker = setInterval(() => {
        localStorage.setItem("nowTime", new Date().getTime());
        localStorage.setItem("callTime", this.getCallTime("nowTime", "callStartTime"));
        this.diffTime = localStorage.getItem("callTime");
      }, 1000);
    },

    stopTimer() {
      this.dispositionOpen = true;
      localStorage.setItem("callEndTime", new Date().getTime());
      clearInterval(this.timeTracker);
      this.timeTracker = "";
    },

    getCallTime(time1, time2) {
      time1 = localStorage.getItem(time1);
      time2 = localStorage.getItem(time2);
      return Math.floor(time1) - Math.floor(time2);
    },

    restart(value) {
      return value ? this.trackCallTime() : this.callActive = false;
    }
  },

  computed: {
    callTime() {
      return this.hours + " : " + this.minutes + " : " + this.seconds;
    },

    hours() {
      return Math.floor(this.diffTime / 1000 / 60 / 60);
    },

    minutes() {
      return Math.floor(this.diffTime / 1000 / 60) % 60;
    },

    seconds() {
      return Math.floor(this.diffTime / 1000) % 60;
    },

    callLength() {
      if (Math.floor(this.diffTime / 1000 / 60) >= 5 && Math.floor(this.diffTime / 1000 / 60) < 7) { // b/w 5 & 7 minutes
        return "yellow darken-2";
      } else if (Math.floor(this.diffTime / 1000 / 60) >= 7 && Math.floor(this.diffTime / 1000 / 60) < 10) { // b/w 7 & 10 minutes
        return "warning";
      } else if (Math.floor(this.diffTime / 1000 / 60) >= 10) { // more than 10 minutes
        return "error";
      } else {
        return "success";
      }
    },

    flash() {
      if (this.seconds % 5 === 0) {
        return true;
      } else {
        return false;
      }
    },

    emoji() {
      if (Math.floor(this.diffTime / 1000 / 60) >= 5 && Math.floor(this.diffTime / 1000 / 60) < 7) { // b/w 5 & 7 minutes
        return "🙂";
      } else if (Math.floor(this.diffTime / 1000 / 60) >= 7 && Math.floor(this.diffTime / 1000 / 60) < 10) { // b/w 7 & 10 minutes
        return "😐";
      } else if (Math.floor(this.diffTime / 1000 / 60) >= 10) { // over 10 minutes
        return "😫";
      } else {
        return "😁";
      }
    }
  },

  filters: {
    zeroPad(value, num) {
      num = typeof num !== "undefined" ? num : 2;
      return value.toString().padStart(num, "0");
    }
  },

  created() {
    this.startTimer();
  },

  components: {
    Disposition
  }
};
</script>

<style>

</style>
